<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 廣告點擊率分析</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <!-- 查詢區 -->
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <form @submit.prevent="onSearch">
                  <!-- 效期區間 -->
                  <div class="row">
                    <label class="control-label col-md-2 mt-2">廣告效期區間：</label>
                    <div class="col-md-3">
                      <input type="date" class="form-control" v-model="filters.sdate" max="9999-12-31" />
                    </div>
                    <label class="mt-2">至</label>
                    <div class="col-md-3">
                      <input type="date" class="form-control" v-model="filters.edate" :min="filters.sdate" max="9999-12-31" />
                    </div>
                    <div class="col-md-3">
                      <button type="submit" class="btn btn-ptc1">查詢</button>
                      <button type="button" class="btn btn-ptc1 ml-2" @click="resetFilters">重設</button>
                    </div>
                  </div>
                  <!-- 品牌 -->
                  <div class="row mt-3">
                    <label class="control-label col-md-2">品牌：</label>
                    <div class="col-md-3">
                      <b-form-select v-model="filters.brandCode" :options="brandOptions"></b-form-select>
                    </div>
                  </div>
                  <!-- 活動名稱 -->
                  <div class="row mt-3">
                    <label class="control-label col-md-2">活動名稱：</label>
                    <div class="col-md-3">
                      <input type="text" class="form-control" v-model.trim="filters.title" maxlength="128" placeholder="關鍵字搜尋" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>

      <!-- 資料區 -->
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <b-tabs ref="tabs" card class="tab_color">
              <!-- 最新活動 -->
              <b-tab title="最新活動" active @click="clickTab(1)">
                <div class="row">
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped table-break">
                        <thead class="text-nowrap">
                        <tr>
                          <th width="60px">排序</th>
                          <th>品牌</th>
                          <th>活動名稱</th>
                          <th width="100px">總會員數</th>
                          <th width="110px">總點擊次數</th>
                          <th width="80px">點擊率</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(x, index) in dataList_all" :key="x.ID">
                          <td>
                            <!-- ★ inline style 強制 32x32 -->
                            <img
                              v-if="index===0 && pageInfo_all.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/gold_one.png"
                            />
                            <img
                              v-else-if="index===1 && pageInfo_all.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/silver_two.png"
                            />
                            <img
                              v-else-if="index===2 && pageInfo_all.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/copper_three.png"
                            />
                            <span class="font-center" v-else>
                                {{ ((pageInfo_all.currentPage-1)*pageInfo_all.pageRows+index+1) }}
                              </span>
                          </td>
                          <td>{{ x.brandCode }}</td>
                          <td>{{ x.title }}</td>
                          <td>{{ x.memberQty }}</td>
                          <td>{{ x.visited }}</td>
                          <td>{{ x.histRate }}%</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination
                        size="md"
                        :total-rows="pageInfo_all.totalRows"
                        v-model="pageInfo_all.currentPage"
                        :per-page="pageInfo_all.pageRows"
                        @change="changPage"
                      ></b-pagination>
                      <label style="margin:8px">{{pageInfo_all.startRowNum}}到{{pageInfo_all.endRowNum}}，總共 {{pageInfo_all.totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>

              <!-- 新開幕 -->
              <b-tab title="新開幕" @click="clickTab(2)">
                <div class="row">
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped table-break">
                        <thead class="text-nowrap">
                        <tr>
                          <th width="60px">排序</th>
                          <th>品牌</th>
                          <th>活動名稱</th>
                          <th width="100px">總會員數</th>
                          <th width="110px">總點擊次數</th>
                          <th width="80px">點擊率</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(x, index) in dataList_store" :key="x.ID">
                          <td>
                            <img
                              v-if="index===0 && pageInfo_store.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/gold_one.png"
                            />
                            <img
                              v-else-if="index===1 && pageInfo_store.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/silver_two.png"
                            />
                            <img
                              v-else-if="index===2 && pageInfo_store.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/copper_three.png"
                            />
                            <span class="font-center" v-else>
                                {{ ((pageInfo_store.currentPage-1)*pageInfo_store.pageRows+index+1) }}
                              </span>
                          </td>
                          <td>{{ x.brandCode }}</td>
                          <td>{{ x.title }}</td>
                          <td>{{ x.memberQty }}</td>
                          <td>{{ x.visited }}</td>
                          <td>{{ x.histRate }}%</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination
                        size="md"
                        :total-rows="pageInfo_store.totalRows"
                        v-model="pageInfo_store.currentPage"
                        :per-page="pageInfo_store.pageRows"
                        @change="changPage"
                      ></b-pagination>
                      <label style="margin:8px">{{pageInfo_store.startRowNum}}到{{pageInfo_store.endRowNum}}，總共 {{pageInfo_store.totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>

              <!-- APP公告 -->
              <b-tab title="APP公告" @click="clickTab(3)">
                <div class="row">
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped table-break">
                        <thead class="text-nowrap">
                        <tr>
                          <th width="60px">排序</th>
                          <th>品牌</th>
                          <th>活動名稱</th>
                          <th width="100px">總會員數</th>
                          <th width="110px">總點擊次數</th>
                          <th width="80px">點擊率</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(x, index) in dataList_member" :key="x.ID">
                          <td>
                            <img
                              v-if="index===0 && pageInfo_member.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/gold_one.png"
                            />
                            <img
                              v-else-if="index===1 && pageInfo_member.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/silver_two.png"
                            />
                            <img
                              v-else-if="index===2 && pageInfo_member.currentPage === 1"
                              class="icon_img"
                              style="width:32px!important;height:32px!important;object-fit:contain;"
                              src="../../../assets/copper_three.png"
                            />
                            <span class="font-center" v-else>
                                {{ ((pageInfo_member.currentPage-1)*pageInfo_member.pageRows+index+1) }}
                              </span>
                          </td>
                          <td>{{ x.brandCode }}</td>
                          <td>{{ x.title }}</td>
                          <td>{{ x.memberQty }}</td>
                          <td>{{ x.visited }}</td>
                          <td>{{ x.histRate }}%</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination
                        size="md"
                        :total-rows="pageInfo_member.totalRows"
                        v-model="pageInfo_member.currentPage"
                        :per-page="pageInfo_member.pageRows"
                        @change="changPage"
                      ></b-pagination>
                      <label style="margin:8px">{{pageInfo_member.startRowNum}}到{{pageInfo_member.endRowNum}}，總共 {{pageInfo_member.totalRows}}筆</label>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '../../../store/root.js'
import miniToastr from 'mini-toastr'
miniToastr.init()

export default {
  data () {
    return {
      filters: {
        sdate: '',
        edate: '',
        brandCode: '',
        title: ''   // 活動名稱模糊搜尋
      },
      brandOptions: [
        { value: '', text: '全部' },
        { value: 'MWD', text: '麥味登' },
        { value: 'CM', text: '炸雞大師' },
        { value: 'REAL', text: 'REAL' },
        { value: 'SJ', text: '涮金鍋' },
      ],
      targetType: 1,
      // 最新活動
      pageInfo_all: { currentPage: 1, totalRows: 0, pageRows: 20, startRowNum: 0, endRowNum: 0 },
      dataList_all: [],
      // 新開幕
      pageInfo_store: { currentPage: 1, totalRows: 0, pageRows: 20, startRowNum: 0, endRowNum: 0 },
      dataList_store: [],
      // APP 公告
      pageInfo_member: { currentPage: 1, totalRows: 0, pageRows: 20, startRowNum: 0, endRowNum: 0 },
      dataList_member: []
    }
  },
  created () {
    this.initFilters()
  },
  methods: {
    initFilters () {
      const today = new Date()
      let firstDay = new Date(today.getFullYear(), today.getMonth() - 2, 0)
      if (firstDay.getDate() >= today.getDate()) {
        firstDay = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate())
      }
      this.filters.sdate = this.dateFormat(firstDay)
      this.filters.edate = this.dateFormat(today)
      this.getData(1, 1)
    },
    resetFilters () {
      this.initFilters()
      this.filters.brandCode = ''
      this.filters.title = ''
    },
    onSearch () {
      this.getData(1, this.targetType)
    },
    dateFormat (d) {
      const y = d.getFullYear()
      const m = ('0' + (d.getMonth() + 1)).slice(-2)
      const day = ('0' + d.getDate()).slice(-2)
      return `${y}-${m}-${day}`
    },
    clickTab (targetType) {
      this.targetType = targetType
      let currentPage = 1
      if (targetType === 1) currentPage = this.pageInfo_all.currentPage
      if (targetType === 2) currentPage = this.pageInfo_store.currentPage
      if (targetType === 3) currentPage = this.pageInfo_member.currentPage
      this.getData(currentPage, targetType)
    },
    changPage (currentPage) {
      this.getData(currentPage, this.targetType)
    },
    getData (currentPage, targetType) {
      if (!this.verification()) return

      let pageRows = 20
      if (targetType === 1) pageRows = this.pageInfo_all.pageRows
      if (targetType === 2) pageRows = this.pageInfo_store.pageRows
      if (targetType === 3) pageRows = this.pageInfo_member.pageRows

      let sdate = this.filters.sdate || '0001-01-01'
      let edate = this.filters.edate || '9999-12-31'
      const brandCode = this.filters.brandCode
      const title = this.filters.title || ''

      this.$parent.Loading = true
      axios.post(API_URL + '/web/information/getpageadhitsrate/v1', {
        sdate: sdate.replace(/-/g, '') + '000000',
        edate: edate.replace(/-/g, '') + '235959',
        targetType: targetType,
        page: currentPage,
        pageRows: pageRows,
        brandCode: brandCode,
        title: title
      })
        .then(res => {
          const data = res.data
          if (data.result === '0000') {
            this.handleResponse(targetType, data)
          } else if (data.result === '0006') {
            this.$parent.logOut(false, true)
          } else {
            miniToastr.error(data.message, '錯誤訊息')
          }
          this.$parent.Loading = false
        })
        .catch(err => {
          miniToastr.error(err, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    handleResponse (targetType, data) {
      if (targetType === 1) {
        this.dataList_all = data.data
        this.pageInfo_all.totalRows = data.totalRows || 0
        this.pageInfo_all.currentPage = data.pageNumber
        this.pageInfo_all.startRowNum = this.calcStart(this.pageInfo_all)
        this.pageInfo_all.endRowNum = this.calcEnd(this.pageInfo_all)
      } else if (targetType === 2) {
        this.dataList_store = data.data
        this.pageInfo_store.totalRows = data.totalRows || 0
        this.pageInfo_store.currentPage = data.pageNumber
        this.pageInfo_store.startRowNum = this.calcStart(this.pageInfo_store)
        this.pageInfo_store.endRowNum = this.calcEnd(this.pageInfo_store)
      } else if (targetType === 3) {
        this.dataList_member = data.data
        this.pageInfo_member.totalRows = data.totalRows || 0
        this.pageInfo_member.currentPage = data.pageNumber
        this.pageInfo_member.startRowNum = this.calcStart(this.pageInfo_member)
        this.pageInfo_member.endRowNum = this.calcEnd(this.pageInfo_member)
      }
    },
    calcStart (info) {
      return info.totalRows === 0 ? 0 : info.pageRows * (info.currentPage - 1) + 1
    },
    calcEnd (info) {
      if (info.totalRows === 0) return 0
      const end = info.currentPage * info.pageRows
      return end >= info.totalRows ? info.totalRows : end
    },
    verification () {
      if (this.filters.sdate && this.filters.edate) {
        const start = new Date(this.filters.sdate)
        const end = new Date(this.filters.edate)
        if (end < start) {
          miniToastr.error('開始時間不可大於結束時間', '錯誤訊息')
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.box-shadow {
  box-shadow: 0 0 1px 1px #cfcfcf;
}

.table-break {
  word-break: break-all;
}

.text-nowrap > tr > th {
  white-space: nowrap;
}

table.table > tbody > tr > td {
  vertical-align: middle;
  height: 59px;
}

.font-center {
  padding-left: 12px;
  font-size: 19px;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/adHitsRate/List.vue